import { render, staticRenderFns } from "./BaseResourceSelector.vue?vue&type=template&id=1d5e526e"
import script from "./BaseResourceSelector.vue?vue&type=script&lang=ts"
export * from "./BaseResourceSelector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports